export const bodyTypesMatrix = [
  [
    ['pear', 'pear', 'hour glass'],
    ['pear', 'pear', 'inverted triangle'],
    ['apple', 'apple', 'rectangle']
  ],
  [
    ['pear', 'pear', 'hour glass'],
    ['rectangle', 'rectangle', 'inverted triangle'],
    ['pear', 'apple', 'inverted triangle']
  ],
  [
    ['inverted triangle', 'pear', 'hour glass'],
    ['rectangle', 'inverted triangle', 'inverted triangle'],
    ['apple', 'inverted triangle', 'inverted triangle']
  ]
]

export const howTo = {
  'hour-glass': 'To softly flaunt her silhouette and accentuate \n' +
    'her proportions choose: fitted clothes - and accessories and clothes \n' +
    'that accentuate the thinnest part of her waist. Her waist should be the focal point',

  pear: 'To balance her frame, choose beautiful detailed tops & accessories and dark \n' +
    'colours for bottoms. To flaunt her body frame, choose items that will \n' +
    'accentuate the thinnest part of her waist and shapely hips.',

  rectangle: 'To create a more feminine body shape, you need to break up her straight\n' +
    'silhouette: choose fitted clothes and belts to create a defined waist. Create \n' +
    'curves add volume and width around shoulders, hipline and thighs to create a curvier frame',

  'inverted-triangle': 'To balance her frame, create curves add volume and width around the \n' +
    'hipline and thighs to downplay her broad shoulders. To flaunt her frame and maintain a \n' +
    'proportioned silhouette, choose waist fitted clothes and bottoms with flare or well \n' +
    'structured to show off her great legs.',

  apple: 'To create a more feminine body shape, you need to break up her straight silhouette and disguise her \n' +
    'extra weight around the stomach: choose structured clothes to recreate a waistline. Draw \n' +
    'attention towards torso and lower body to focus attention on her best assets: breasts and legs.'

}
